<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg-but-on-mobile-default">
      <div :class="{ 'max-w-container-text': data.size?.value !== 'lg' }">
        <figure>
          <AppImage
            v-if="data.image"
            v-animate-zoom-in
            :src="data.image"
            class="h-full object-contain object-left"
            quality="auto:best:sensitive"
            :class="data.size?.value === 'lg' ? 'max-h-[80vh]' : 'max-h-[60vh]'"
            :alt="useMapAltText(data.image)"
          />

          <figcaption class="mt-2">
            <span
              v-if="data.caption"
              class="typo-body-md sm:typo-body-lg"
            >{{ data.caption }}</span>
          </figcaption>
        </figure>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsMainImageFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainImageFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)
</script>
